import { render } from "./TableRiskStatusCount.vue?vue&type=template&id=60830193"
import script from "./TableRiskStatusCount.vue?vue&type=script&lang=js"
export * from "./TableRiskStatusCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__